import React from "react";
import sealImage from "../../../semantic/dist/themes/fibrestream/assets/images/guarantee_seal_3D.png";

const SatisfactionGuaranteed = () => (
  <section className="ui inverted segment vertical center aligned guaranteed">
    <div className="ui container">
      <div className="ui grid centered my-0">
        <div className="drop-shadow px-8">
          <img src={sealImage} alt="100% Guaranteed" width="170" height="170"/>
        </div>
      </div>
      <h3 className="title">SINCE 2009</h3>
      <div className="display-1 itc">Satisfaction Guaranteed</div>
    </div>
  </section>
);

export default SatisfactionGuaranteed;
/* gradient floor: */



// WEBPACK FOOTER //
// ./src/components/home/satisfaction-guaranteed/SatisfactionGuaranteed.js